<template>
    <div class="title-box">
        <span class="title" v-html="text"></span>
    </div>
</template>
<script>
    export default {
        name: 'Title',
        props: {
            text: {
                type: String,
                required: true
            },
        },
    }
</script>
<style lang="scss" scoped>
    .title-box{
        width: 100%;
        height: 70px;
        line-height: 80px;
        text-align: center;
        background: url("./img/bg.png");
        background-size: 100% 100%;
        .title{
            color: #F84025;
            font-size: 21px;
            position: relative;
            &:after{
                content: '';
                margin-left: 10px;
                margin-bottom: 2px;
                transform: rotate(27deg);
                display: inline-block;
                width: 2px;
                height: 10px;
                background: #F84025;
            }
            &:before{
                content: '';
                margin-right: 10px;
                margin-bottom: 2px;
                transform: rotate(27deg);
                display: inline-block;
                width: 2px;
                height: 10px;
                background: #F84025;
            }
        }
    }
</style>
